export enum FiTaskType {
    Common = 0,
    ChecklistAutomated = 1,
    ChecklistOneTime = 2,
}

export enum FiTaskStatusType {
    NotStarted = 0,
    InProcess = 1,
    Completed = 2,
    Cancelled = 3,
}

export enum FiTaskPriorityType {
    Low = 0,
    Medium = 1,
    High = 2,
}

export enum FiTaskCategoryType {
    AssignedByMe = 0,
    AssignedToMe = 1,
    Private = 2,
    AssignedToOthers = 3,
}

export enum FiTaskAssignmentType {
    Private = 0,
    Users = 1,
    RolesUnits = 2,
}

export enum FiTaskColumns {
    DeadlineColumn = 'Deadline',
    PriorityColumn = 'Priority',
    StatusColumn = 'Status',
    CompletedOnColumn = 'CompletedOn',
}

export enum FiTaskActionType {
    SetCompleted = 0,
    SetNotStarted = 1,
    Archive = 2,
    Restore = 3,
    Create = 4,
    Start = 5,
    Cancel = 6,
    AddUser = 7,
    Reopened = 9,
    ReopenedAndSetInProcess = 10,
    UpdatePriority = 11,
    UpdateDeadline = 12,
    UpdateSharingSelection = 13,
}
